// O'qish faolligi sahifalari uchun ko'rsatish yordamchilari (faqat formatlash, API yo'q).
import { parseServerDate } from '../../utils/serverDate';

export const EMPTY = '—';

export const WEEKDAYS = ['Du', 'Se', 'Ch', 'Pa', 'Ju', 'Sh', 'Ya'];

// 40 → "40 son", 540 → "9 daq", 3725 → "1 soat 2 daq"
export function formatDuration(seconds) {
  const total = Math.max(0, Math.round(Number(seconds) || 0));
  if (total === 0) return '0 daq';
  if (total < 60) return `${total} son`;
  const hours = Math.floor(total / 3600);
  const minutes = Math.floor((total % 3600) / 60);
  if (!hours) return `${minutes} daq`;
  return minutes ? `${hours} soat ${minutes} daq` : `${hours} soat`;
}

export const toMinutes = (seconds) => Math.round((Number(seconds) || 0) / 60);

const pad = (value) => String(value).padStart(2, '0');

// Video ichidagi nuqta: 270 → "4:30", 3725 → "1:02:05"
export function formatVideoTime(seconds) {
  const total = Math.max(0, Math.floor(Number(seconds) || 0));
  const hours = Math.floor(total / 3600);
  const minutes = Math.floor((total % 3600) / 60);
  const rest = total % 60;
  return hours ? `${hours}:${pad(minutes)}:${pad(rest)}` : `${minutes}:${pad(rest)}`;
}

export const formatVideoRange = (start, length) =>
  `${formatVideoTime(start)}–${formatVideoTime(start + length)}`;

export function formatInactiveDays(days) {
  if (days === null || days === undefined) return 'Hech qachon';
  if (days <= 0) return 'Bugun';
  if (days === 1) return 'Kecha';
  return `${days} kun oldin`;
}

// O'zbekistonda yozgi vaqt yo'q — Toshkent doimo UTC+5
const TASHKENT_OFFSET_MS = 5 * 3600 * 1000;
const DAY_MS = 24 * 3600 * 1000;
const tashkentDay = (ms) => Math.floor((ms + TASHKENT_OFFSET_MS) / DAY_MS);

// Server sanasidan (UTC) bugungacha necha kun o'tgan — Toshkent kalendari bo'yicha
export function daysSince(value, now = Date.now()) {
  const ms = parseServerDate(value);
  if (ms === null) return null;
  return tashkentDay(now) - tashkentDay(ms);
}

// "2026-10-25" → "25.10" (o'q) / "25.10.2026" (to'liq)
export function formatDay(isoDate, { withYear = false } = {}) {
  const [year, month, day] = String(isoDate || '').split('-');
  if (!year || !month || !day) return EMPTY;
  return withYear ? `${day}.${month}.${year}` : `${day}.${month}`;
}

// Issiqlik xaritasi katagi: 0 — ko'rilmagan, 1..5 — eng ko'p ko'rilgan soatga nisbatan
export function heatLevel(seconds, max) {
  if (!(seconds > 0) || !(max > 0)) return 0;
  return Math.min(5, Math.max(1, Math.ceil((seconds / max) * 5)));
}

// Talaba sahifasidagi dars holati
export function lessonStatus(row) {
  if (row.completed_at) return { label: "Ko'rib tugatildi", variant: 'success' };
  if (row.is_current) return { label: 'Joriy', variant: 'info' };
  if (row.is_passed) return { label: "O'tilgan", variant: 'neutral' };
  if (row.watched_sec > 0) return { label: 'Boshlangan', variant: 'warning' };
  return { label: 'Boshlanmagan', variant: 'neutral' };
}

export const lessonCode = (row) => `${row.chapter_order}.${row.lesson_order}`;

// Kamera nazorati epizodi (backend: face_absent / look_away)
export const EPISODE_TYPES = {
  face_absent: { label: 'Turib ketdi', variant: 'warning' },
  look_away: { label: 'Boshqa tomonga qaradi', variant: 'info' },
};

export const episodeType = (type) => EPISODE_TYPES[type] || { label: type, variant: 'neutral' };
